import { Initializer } from 'common/types/initializers';
import App from 'common/backbone-app';
import React from 'react';
import ReactDOM from 'react-dom';
import { Reconnect } from 'src/federation/Reconnect';

type AppointmentFeeInfoInitializerProps = {
  node: HTMLElement;
  appointment: Record<string, unknown>;
  appointmentGroup?: Record<string, unknown>;
  viewFinanceData: boolean;
};

export const AppointmentFeeInfoInitializer = (
  props: AppointmentFeeInfoInitializerProps,
): Initializer => {
  const { node, ...feeInfoProps } = props;
  const destroy = () => ReactDOM.unmountComponentAtNode(node);

  const onOrderReferenceClick = () => {
    const orderId = feeInfoProps.appointment?.orderId;
    if (!orderId) {
      return;
    }

    const view = new App.Views.Dialog.Order2({
      model: new App.Models.Order({ id: orderId }),
      updateUrl: false,
    });
    view.render();
    view.open();
  };

  const render = () => {
    ReactDOM.render(
      <Reconnect
        name="AppointmentFeeInfo"
        props={{
          ...feeInfoProps,
          onOrderReferenceClick,
        }}
      />,
      node,
    );
  };

  return { destroy, render };
};
